export default {
  // Rate Warehouse
  rateWarehouse: {
    title: 'Rate Warehouse',

    // Tabs
    tabs: {
      fcl: 'Ocean FCL',
      lcl: 'Ocean LCL',
      air: 'Air Freight',
      preport: 'Pre-port Rate',
      lastmile: 'Last Mile Rate'
    },
    tabPlaceholder: 'Click to switch to {title} to load page',

    segmentRoute: {
      serviceType: 'Service Type',
      transportMode: 'Transport Mode',
      addressType: 'Address Type',
      trailer: 'Trailer',
      barge: 'Barge',
      rail: 'Rail',
      seaPort: 'Seaport',
      railwayStation: 'Railway Station',
      airport: 'Airport',
      loadingPlace: 'Loading Place',
      destinationPlace: 'Destination',
      shippingCompany: 'Shipping Company',
      railwayCompany: 'Railway Company',
      bargeVessel: 'Barge Vessel',
      bargeVoyage: 'Barge Voyage',
      trainNo: 'Train No.',
      transportDays: 'Transit Time (Days)',
      bargeDepartureTime: 'Barge Departure Time',
      bargeArrivalTime: 'Barge Arrival Time',
      trainDepartureTime: 'Estimated Departure Time',
      loadingRailwayStation: 'Loading Railway Station',
      destinationRailwayStation: 'Destination Railway Station',
      validation: {
        transportMode: 'Please select transport mode',
        addressType: 'Please select address type'
      }
    },
    // Common (shared between FCL/LCL)
    common: {
      // Column titles
      columns: {
        priceNo: 'Rate No.',
        source: 'Rate Source',
        status: 'Rate Status',
        cargoType: 'Cargo Type',
        supplierId: 'Supplier',
        relatedNo: 'Reference No.',
        carrierId: 'Carrier',
        originCountry: 'Origin Country',
        destinationCountry: 'Destination Country',
        contractNo: 'Contract No.',
        cargoDesc: 'Cargo Description',
        transportMode: 'Transport Mode',
        routeType: 'Route Type',
        containerOwnership: 'Container Ownership',
        pol: 'Port of Loading (POL)',
        polTerminal: 'POL Terminal',
        pod: 'Port of Discharge (POD)',
        podTerminal: 'POD Terminal',
        pdl: 'Place of Delivery',
        por: 'Place of Receipt',
        portOfDischarge: 'Place of Delivery (PDL)',
        placeOfDelivery: 'Place of Receipt (POR)',
        directFlag: 'Direct/Transit',
        transitPort: 'Transit Port',
        pot1: 'Transit Port 1',
        pot2: 'Transit Port 2',
        pot3: 'Transit Port 3',
        vessel: 'Vessel',
        voyage: 'Voyage',
        laneCode: 'Lane Code',
        sailingDays: 'Sailing Days',
        cutoffDays: 'Cut-off Days',
        etd: 'ETD',
        eta: 'ETA',
        beginDate: 'Effective Date',
        endDate: 'Expiry Date',
        freeDetentionDays: 'Free Detention Days',
        freeDemurrageDays: 'Free Demurrage Days',
        unpackDelivery: 'Devan Delivery',
        weightLimit: 'Weight Limit',
        receivingInstructions: 'Special Instructions',
        remarks: 'Remarks',
        operations: 'Actions'
      },

      // Actions
      actions: {
        create: 'Create',
        import: 'Import',
        search: 'Search',
        view: 'View',
        edit: 'Edit',
        copy: 'Copy',
        more: 'More',
        enable: 'Enable',
        disable: 'Disable',
        delete: 'Delete',
        back: 'Back',
        saveDraft: 'Save Draft',
        save: 'Save',
        add: 'Add',
        batchOperations: 'Batch Operations',
        batchEnable: 'Batch Enable',
        batchDisable: 'Batch Disable',
        batchDelete: 'Batch Delete'
      },

      importDialog: {
        title: '{type} Import',
        downloadTemplate: 'Download Import Template',
        reminderTitle: 'Tips',
        reminderLine1: 'Uploading creates a background import task. Check Task Management for results.',
        reminderLine2: 'The system validates template fields and writes valid rows into the rate warehouse.',
        fileLimit: 'Only .xls / .xlsx files up to 10MB are supported.',
        selectFile: 'Click or drag an Excel file here',
        submit: 'Upload and Import',
        uploading: 'Submitting import task...',
        invalidFileType: 'Only xls and xlsx files are supported',
        fileTooLarge: 'File size cannot exceed 10MB',
        selectFileFirst: 'Please select an import file',
        submitSuccess: 'Import task submitted. Check Task Management for results.',
        downloadFailed: 'Failed to download template',
        uploadFailed: 'Failed to submit the import task. Please try again later.'
      },

      // Messages
      messages: {
        loadFailed: 'Failed to load data',
        enableSuccess: 'Enabled successfully',
        disableSuccess: 'Disabled successfully',
        operationFailed: 'Operation failed',
        batchEnableSuccess: 'Batch enable succeeded',
        batchDisableSuccess: 'Batch disable succeeded',
        batchDeleteSuccess: 'Batch delete succeeded',
        deleteSuccess: 'Deleted successfully',
        deleteFailed: 'Failed to delete',
        saveDraftSuccess: 'Draft saved',
        saveSuccess: 'Saved successfully',
        updateSuccess: 'Updated successfully',
        saveFailed: 'Failed to save',
        saveDraftFailed: 'Failed to save draft',
        loadDetailFailed: 'Failed to load rate details',
        copyTip: 'Original rate details copied. A new rate number will be generated after saving.',
        missingId: 'Missing rate ID, cannot load details',
        notFound: 'Rate details not found',
        missingIdSaveDraft: 'Missing rate ID, cannot save draft',
        missingIdSave: 'Missing rate ID, cannot save',
        fillRequired: 'Please complete all required fields',
        feeDataCacheFailed: 'Failed to load fee data cache:',
        duplicateFeeItem: 'This fee item already exists in the surcharge list, duplicates are not allowed',
        duplicateContainerType: 'This container type already exists in the sea freight list, duplicates are not allowed',
        minOneContainerColumn: 'At least one container column must be kept',
        selectAtLeastOneColumn: 'Please select at least one container column',
        allInPriceTip: 'This rate was imported from an All In Price quotation. Surcharges are not added during calculation.'
      },

      // Confirm dialogs
      confirm: {
        deleteTitle: 'Delete Confirmation',
        deleteContent: 'Are you sure to delete this rate?',
        batchEnableTitle: 'Batch Enable',
        batchEnableContent: 'Are you sure to enable the selected {count} rates?',
        batchDisableTitle: 'Batch Disable',
        batchDisableContent: 'Are you sure to disable the selected {count} rates?',
        batchDeleteTitle: 'Batch Delete',
        batchDeleteContent: 'Are you sure to delete the selected {count} rates? This action cannot be undone.'
      },

      // Sections
      sections: {
        basicInfo: 'Basic Information',
        timelinessInfo: 'Timeliness Information',
        scheduleInfo: 'Schedule Information',
        feeInfo: 'Fee Information',
        remarkInfo: 'Remark Information'
      },

      // Fields (beyond column titles)
      fields: {
        validPeriod: 'Validity Period',
        tradeTermsId: 'Trade Terms',
        onePrice: 'All In Price',
        combinationType: 'Combination Type',
        specifiedMatchCodes: 'Specified Match Rates',
        specifiedDestRegions: 'Specified Destination Regions',
        specifiedDestRegionLogic: 'Destination Region Logic',
        allInPriceIncludedItems: 'All In Price Included Items',
        allInPriceRemarks: 'All In Price Remarks',
        potentialFeeType: 'Potential Fee Type',
        timelinessAchievementRate: 'On-time Performance Rate (%)',
        carrierPromiseDays: 'Carrier End-to-End Commitment',
        pickupLeadTime: 'Pickup Lead Time',
        portToPortDays: 'Port-to-Port Transit Time',
        clearanceDeliveryDays: 'Clearance & Delivery Time',
        freeDetentionDaysLabel: 'Free Detention Days (days)',
        freeDemurrageDaysLabel: 'Free Demurrage Days (days)',
        unpackDeliveryLabel: 'Devan Delivery',
        weightLimitLabel: 'Weight Limit (kg)'
      },

      // Default fee values
      feeDefaults: {
        baseFee: 'Base Fee'
      },

      // Placeholders
      placeholders: {
        autoGenerate: 'Auto-generated after saving',
        select: 'Please select',
        input: 'Please enter',
        relatedNo: 'Inquiry/Tender No.',
        cargoDesc: 'Cargo description',
        searchPriceNo: 'Enter rate code and press Enter; leave empty to match all',
        destinationRegions: 'Select routes (multiple; empty means unrestricted)',
        destinationRegionHint: 'Once set, only trunk rates whose destination port route category meets this condition are matched',
        contractNo: 'Related contract No.',
        beginDate: 'Start date',
        endDate: 'End date',
        vessel: 'Vessel name',
        voyage: 'Voyage',
        laneCode: 'Lane code',
        selectDate: 'Select date',
        potentialFeeType: 'Please select a potential fee type',
        freeDetentionDays: 'Enter free detention days',
        freeDemurrageDays: 'Enter free demurrage days',
        weightLimit: 'Enter weight limit',
        receivingInstructions: 'Enter special instructions',
        remarks: 'Enter remarks',
        all: 'All',
        selectDate2: 'Select date'
      },

      options: {
        freeCombination: 'Free combination',
        preciseCombination: 'Precise combination',
        include: 'Include',
        exclude: 'Exclude'
      },

      // Validation
      validation: {
        status: 'Please select rate status',
        supplierId: 'Please select supplier',
        cargoType: 'Please select cargo type',
        validPeriod: 'Please select validity period',
        transportMode: 'Please select transport mode',
        routeType: 'Please select route type',
        carrierId: 'Please select carrier',
        pol: 'Please select Port of Loading (POL)',
        pod: 'Please select Port of Discharge (POD)',
        sailingDays: 'Please select sailing days',
        cutoffDays: 'Please select cut-off days',
        directFlag: 'Please select direct/transit',
        surchargeSelectPotentialFeeType: 'Surcharge row {index}: please select a valid potential fee type',
        endDateBeforeBeginDate: 'End date must be equal to or later than start date',
        fillRequired: 'Please complete all required fields',
        polOrPlaceOfDelivery: 'At least one of Place of Receipt or POL must be filled',
        podOrPortOfDischarge: 'At least one of Place of Delivery or POD must be filled'
      },

      // Units
      units: {
        day: 'days'
      }
    },

    // Enum i18n
    enums: {
      source: {
        inquiry: 'Inquiry Import',
        bidding: 'Bidding Import',
        manual: 'Manual Entry',
        system: 'System Generated'
      },
      status: {
        normal: 'Active',
        expired: 'Expired',
        disabled: 'Disabled'
      },
      routeType: {
        economy: 'Economy Route',
        express: 'Express Route'
      },
      directFlag: {
        direct: 'Direct',
        transit: 'Transit',
        directTransit: 'Direct/Transit'
      },
      feeType: {
        transportFee: 'Transport Fee',
        airFreight: 'Air Freight Surcharge',
        oceanFreight: 'Ocean Freight Surcharge',
        portFee: 'Origin Port Fee',
        destinationPortFee: 'Destination Port Fee',
        otherFee: 'Other Fee',
        potentialFee: 'Potential Fee',
        prePortSurcharge: 'Pre-port Surcharge',
        lastMileSurcharge: 'Last-mile Surcharge'
      },
      potentialFeeType: {
        seaSurcharge: 'Ocean freight surcharge',
        airSurcharge: 'Air freight surcharge',
        seaOrigin: 'Origin port charge',
        seaDestination: 'Destination port charge',
        airOrigin: 'Origin charge',
        airDestination: 'Destination charge'
      },
      yesNo: {
        yes: 'Yes',
        no: 'No'
      },
      weekday: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      },
      cargoType: {
        general: 'General Cargo',
        dangerous: 'Dangerous Goods',
        reefer: 'Reefer Cargo',
        special: 'Special Container',
        steelCoil: 'Steel Coil',
        liquid: 'Liquid',
        chemical: 'Chemical',
        textile: 'Textile',
        reeferDangerous: 'Cold Hazardous Goods'
      }
    },

    // FCL
    fcl: {
      createTitle: 'New FCL Rate',
      editTitle: 'Edit FCL Rate',
      viewTitle: 'FCL Rate Details',
      copyTitle: 'Copy FCL Rate',

      columns: {
        pod: 'Port of Discharge (POD)',
        podTerminal: 'POD Terminal',
        chargingItems: 'Fee Information'
      },

      feeTable: {
        seaFreightTitle: 'Ocean Freight',
        containerType: 'Container Type',
        billingUnit: 'Billing Unit',
        currency: 'Currency',
        oceanFreight: 'Ocean Freight',
        operations: 'Actions'
      },

      surcharge: {
        title: 'Surcharge Details',
        addContainerColumn: 'Add Container Column',
        feeName: 'Fee Name',
        feeType: 'Fee Type',
        includedInBasePrice: 'Included in Ocean Freight',
        unit: 'Unit',
        currency: 'Currency',
        unitRate: 'Unit Rate',
        min: 'Min',
        max: 'Max',
        remarks: 'Fee Remarks',
        selectContainerTitle: 'Select Surcharge Container Columns',
        removeColumnAriaLabel: 'Remove {label} column',
        minOneContainerColumn: 'At least one container column must be retained',
        selectAtLeastOneColumn: 'Please select at least one container column'
      },

      validation: {
        pod: 'Please select Port of Discharge (POD)',
        seaFeeSelectContainer: 'Sea freight row {index}: please select container type',
        seaFeeDuplicateContainer: 'Sea freight row {index}: duplicate container type',
        seaFeeSelectBillingUnit: 'Sea freight row {index}: please select billing unit',
        seaFeeDuplicateBillingUnit: 'Sea freight row {index}: duplicate billing unit',
        seaFeeSelectCurrency: 'Sea freight row {index}: please select currency',
        seaFeeInputAmount: 'Sea freight row {index}: please enter ocean freight',
        surchargeSelectFee: 'Surcharge row {index}: please select fee name',
        surchargeDuplicateFee: 'Surcharge row {index}: duplicate fee name',
        surchargeSelectCurrency: 'Surcharge row {index}: please select currency',
        surchargeSelectUnit: 'Surcharge row {index}: please select unit',
        surchargeInputUnitRate: 'Surcharge row {index}: please enter unit rate',
        surchargeInputContainerFee: 'Surcharge row {index}: please enter at least one container fee'
      }
    },

    // LCL
    lcl: {
      createTitle: 'New LCL Rate',
      editTitle: 'Edit LCL Rate',
      viewTitle: 'LCL Rate Details',
      copyTitle: 'Copy LCL Rate',

      columns: {
        pod: 'Port of Discharge (POD)',
        podTerminal: 'POD Terminal',
        tradeTermsId: 'Trade Terms'
      },

      feeSection: {
        title: 'Fee Details',
        feeName: 'Fee Name',
        currency: 'Currency',
        billingUnit: 'Billing Unit',
        unitRate: 'Unit Rate',
        minConsume: 'Minimum Charge',
        defaultFeeName: 'Basic Ocean Freight',
        unitRatePlaceholder: 'Ocean freight rate',
        minConsumePlaceholder: 'Minimum charge amount'
      },

      surcharge: {
        title: 'Surcharge Details',
        feeName: 'Fee Name',
        feeType: 'Fee Type',
        currency: 'Currency',
        unit: 'Unit',
        unitRate: 'Unit Rate',
        min: 'Min',
        max: 'Max',
        remarks: 'Remarks',
        operations: 'Actions'
      },

      validation: {
        pod: 'Please select Port of Discharge (POD)',
        currency: 'Please select fee currency',
        unitRate: 'Please enter fee unit rate',
        surchargeDuplicateFee: 'Surcharge row {index}: duplicate fee name',
        surchargeSelectFeeType: 'Surcharge row {index}: please select fee type',
        surchargeSelectCurrency: 'Surcharge row {index}: please select currency',
        surchargeSelectUnit: 'Surcharge row {index}: please select unit',
        surchargeInputUnitRate: 'Surcharge row {index}: please enter unit rate'
      }
    },

    // Scaffold (shared by air/preport/lastmile)
    scaffold: {
      sourceOptions: {
        inquiry: 'Inquiry Import',
        template: 'Template Import',
        manual: 'Manual Entry'
      },
      statusOptions: {
        enabled: 'Active',
        disabled: 'Expired'
      },
      labels: {
        rateNo: 'Rate No.',
        source: 'Rate Source',
        status: 'Rate Status',
        validPeriod: 'Validity'
      },
      defaultOriginLabel: 'POL',
      defaultDestinationLabel: 'POD'
    },

    // Air
    air: {
      createTitle: 'New Air Rate',
      editTitle: 'Edit Air Rate',
      viewTitle: 'Air Rate Details',
      copyTitle: 'Copy Air Rate',

      columns: {
        rateNo: 'Rate No.',
        source: 'Rate Source',
        airline: 'Airline',
        departureAirport: 'Departure Airport',
        destinationAirport: 'Destination Airport',
        pickupAddress: 'Pickup Address',
        destination: 'Final Destination',
        routeGrade: 'Route Grade',
        packageType: 'Package Type',
        directFlag: 'Direct/Transit',
        flightNo: 'Flight No.',
        aircraftType: 'Aircraft Type',
        flightSchedule: 'Flight Schedule',
        estimatedDepartureTime: 'Estimated Departure Time',
        estimatedArrivalTime: 'Estimated Arrival Time',
        voyageTime: 'Voyage Time',
        voyageTimeUnit: 'Time Unit',
        chargingItems: 'Charging Items',
        freeDetentionDays: 'Airport Free Days',
        freeDemurrageDays: 'CFS Free Days',
        specialInstructions: 'Special Instructions',
        capacityCbm: 'Capacity (CBM)',
        transitAirports: 'Transit Airports',
        baseRemarks: 'Base Remarks'
      },
      originLabel: 'Departure Airport',
      destinationLabel: 'Destination Airport',
      enums: {
        routeGrade: {
          normal: 'Normal',
          express: 'Express'
        },
        directFlag: {
          direct: 'Direct',
          transit: 'Transit',
          both: 'Direct + Transit'
        },
        packageType: {
          bulk: 'Bulk',
          pallet: 'Pallet'
        },
        cargoType: {
          general: 'General Cargo',
          magnetic: 'Magnetic',
          battery: 'Battery',
          magneticBattery: 'Magnetic & Battery'
        },
        voyageTimeUnit: {
          hour: 'Hours',
          day: 'Days',
          minute: 'Minutes'
        }
      },
      durationUnits: {
        day: 'Day',
        hour: 'Hour',
        minute: 'Minute',
        compactDay: 'D',
        compactHour: 'H',
        compactMinute: 'M'
      },
      placeholders: {
        flightNo: 'Enter flight number',
        aircraftType: 'Enter aircraft type',
        voyageTime: 'Enter voyage time',
        capacityCbm: 'Enter capacity',
        transitAirports: 'Enter transit airports',
        specialInstructions: 'Enter special instructions',
        baseRemarks: 'Enter remarks'
      },
      sections: {
        flightInfo: 'Flight Information',
        feeDetail: 'Fee Details',
        surchargeDetail: 'Surcharge Items',
        remarkInfo: 'Remarks'
      },
      feeSection: {
        title: 'Freight',
        addRow: 'Add Row',
        densityDegree: 'Density Grade',
        currency: 'Currency',
        minConsume: 'Min Consume (M)',
        normalValency: 'Normal Price (N)',
        price45kg: '45KG+',
        price100kg: '100KG+',
        price300kg: '300KG+',
        price500kg: '500KG+',
        price700kg: '700KG+',
        price1000kg: '1000KG+',
        price2000kg: '2000KG+'
      },
      validation: {
        carrierId: 'Please select airline',
        polId: 'Please select departure airport',
        podId: 'Please select destination airport',
        packageType: 'Please select package type',
        directFlag: 'Please select direct/transit',
        transitAirports: 'Please select transit airports',
        surchargeSelectFee: 'Surcharge row {index}: please select fee name',
        surchargeDuplicateFee: 'Surcharge row {index} has duplicate fee name, please check',
        surchargeSelectFeeType: 'Surcharge row {index}: please select fee type',
        surchargeSelectUnit: 'Surcharge row {index}: please select unit',
        surchargeSelectCurrency: 'Surcharge row {index}: please select currency',
        surchargeInputUnitRate: 'Surcharge row {index}: please enter unit rate'
      }
    },

    // Pre-port
    preport: {
      createTitle: 'Create Pre-port Rate',
      editTitle: 'Edit Pre-port Rate',
      viewTitle: 'Pre-port Rate Details',
      copyTitle: 'Copy Pre-port Rate',
      columns: {
        priceNo: 'Rate No.',
        rateNo: 'Rate No.',
        source: 'Rate Source',
        supplier: 'Supplier',
        rateType: 'Rate Type',
        origin: 'Origin',
        pol: 'Origin Port',
        polAirport: 'Origin Airport',
        wharf: 'Terminal',
        originTerminal: 'Origin Terminal',
        originRailwayStation: 'Origin Station',
        airportTerminal: 'Airport Terminal',
        loadingAddressType: 'Address Type',
        warehouseCode: 'Warehouse',
        vehicleType: 'Vehicle Type',
        currency: 'Currency',
        unitRate: 'Unit Rate'
      },
      enums: {
        addressType: {
          thirdParty: 'Third-party Address',
          warehouse: 'Warehouse'
        }
      },

      sections: {
        basicInfo: 'Basic Information',
        loadingInfo: 'Loading Place Information',
        portInfo: 'Origin Port Information',
        regionInfo: 'Third-party Address',
        feeInfo: 'Fee Details',
        surchargeDetail: 'Surcharge Details'
      },
      region: {
        title: 'Region List',
        addRegion: 'Add Region',
        regionIndex: 'Region {index}',
        country: 'Country',
        selectRegionInfo: 'Please select region information',
        administrativeDivision: 'Administrative Division',
        detailedLocation: 'Detailed Location',
        detailedAddress: 'Detailed Address',
        selectProvince: 'Please select province/state',
        selectCity: 'Please select city',
        selectDistrict: 'Please select district',
        selectStreet: 'Please select street',
        selectCommunity: 'Please select community',
        enterDetailedAddress: 'Please enter detailed address',
        atLeastOneRegion: 'Keep at least one region',
        defaultCountryName: 'China'
      },
      placeholders: {
        rateType: 'Please select rate type',
        pol: 'Please select origin port',
        polAirport: 'Please select origin airport',
        wharf: 'Please select terminal',
        airportTerminal: 'Enter airport terminal',
        warehouseCode: 'Select warehouses'
      },
      validation: {
        supplierId: 'Please select supplier',
        cargoType: 'Please select cargo type',
        rateType: 'Please select rate type',
        loadingAddressType: 'Please select address type',
        thirdPartyAddress: 'Please enter the third-party detailed address',
        warehouseCode: 'Please select at least one warehouse',
        validPeriod: 'Please select valid period',
        originSeaport: 'Please select origin port',
        originRailwayStation: 'Please select origin station',
        originAirport: 'Please select origin airport',
        specifiedMatchRequired: 'Specified match rates are required for non-container seaport LCL fees'
      },
      originLabel: 'Origin',
      destinationLabel: 'POL'
    },
    // Last mile
    lastmile: {
      createTitle: 'Create Last Mile Rate',
      editTitle: 'Edit Last Mile Rate',
      viewTitle: 'Last Mile Rate Details',
      copyTitle: 'Copy Last Mile Rate',

      columns: {
        priceNo: 'Rate No.',
        rateNo: 'Rate No.',
        source: 'Rate Source',
        supplier: 'Supplier',
        rateType: 'Rate Type',
        unloadingNodeType: 'Destination Node Type',
        unloadingNode: 'Destination Node',
        unloadingFacility: 'Destination Terminal',
        pod: 'POD',
        podAirport: 'Dest. Airport',
        wharfId: 'Dest. Terminal',
        destinationPort: 'Destination Port',
        destinationTerminal: 'Destination Terminal',
        destinationStation: 'Destination Railway Station',
        destinationAirport: 'Destination Airport',
        unloadingCountry: 'Destination Country',
        airportTerminal: 'Destination Airport Terminal',
        deliveryAddressType: 'Address Type',
        country: 'Country',
        state: 'State',
        city: 'City',
        district: 'District',
        postalCode: 'Postal Code',
        address: 'Address',
        warehouseCode: 'Warehouse',
        destination: 'Destination',
        deliveryMode: 'Delivery Mode',
        currency: 'Currency',
        unitRate: 'Unit Rate',
        min: 'Min',
        max: 'Max'
      },

      enums: {
        addressType: {
          thirdParty: 'Third Party',
          amazon: 'Warehouse',
          warehouse: 'Warehouse'
        },
        cargoType: {
          general: 'General',
          magnetic: 'Magnetic',
          battery: 'Battery',
          magneticBattery: 'Magnetic & Battery'
        },
        rateType: {
          directDrag: 'Direct Drayage',
          branchLine: 'Branch Line',
          seaRail: 'Sea-Rail'
        }
      },

      sections: {
        basicInfo: 'Basic Information',
        addressInfo: 'Address Information',
        destinationInfo: 'Destination Information',
        deliveryAddress: 'Delivery Address',
        portInfo: 'Destination Port / Airport Information',
        feeInfo: 'Fee Details',
        surchargeDetail: 'Surcharge Details'
      },

      placeholders: {
        rateType: 'Please select rate type',
        deliveryAddressType: 'Please select address type',
        postalCode: 'Enter postal code',
        address: 'Enter address',
        warehouseCode: 'Select warehouses',
        pod: 'Please select POD',
        podAirport: 'Please select dest. airport',
        wharfId: 'Please select dest. terminal',
        destinationPort: 'Please select destination port',
        destinationTerminal: 'Please select destination terminal',
        destinationAirport: 'Please select destination airport',
        airportTerminal: 'Enter destination airport terminal'
      },

      validation: {
        supplierId: 'Please select supplier',
        cargoType: 'Please select cargo type',
        rateType: 'Please select rate type',
        deliveryAddressType: 'Please select address type',
        validPeriod: 'Please select valid period',
        pod: 'Please select POD',
        country: 'Please select country',
        state: 'Please select state',
        city: 'Please select city',
        address: 'Please enter address',
        warehouseCode: 'Please select at least one warehouse',
        podOrPodAirport: 'At least one of POD or destination airport is required',
        destinationPort: 'Please select destination port',
        destinationStation: 'Please select destination railway station',
        destinationAirport: 'Please select destination airport',
        specifiedMatchRequired: 'Specified match rates are required for non-container seaport LCL fees'
      },

      feeSection: {
        title: 'Freight',
        addRow: 'Add Fee Row',
        feeName: 'Fee Name',
        nameCn: 'Fee Name (CN)',
        nameEn: 'Fee Name (EN)',
        feeNameByRateType: {
          directDrag: 'Trucking Fee',
          branchLine: 'Delivery Fee',
          seaRail: 'Rail Drayage Fee'
        },
        billingUnit: 'Billing Unit',
        currency: 'Currency',
        unitRate: 'Unit Rate',
        min: 'Min Charge',
        max: 'Max Charge',
        remarks: 'Remarks',
        operations: 'Actions'
      },

      surcharge: {
        title: 'Surcharge Details',
        addContainerColumn: 'Add Container Column',
        feeName: 'Fee Name',
        feeType: 'Fee Type',
        unit: 'Unit',
        currency: 'Currency',
        unitRate: 'Unit Rate',
        min: 'Min',
        max: 'Max',
        remarks: 'Remarks',
        operations: 'Actions'
      },

      originLabel: 'POD',
      destinationLabel: 'Destination'
    }
  }
}
